import React from "react";

import richTextRendererUtils from "@/utils/richTextRenderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Box, CardContent, Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  description: Document | null;
};

export const Card: React.FC<Props> = ({ title, description }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex"
      }}
    >
      <Stack
        sx={{
          borderRadius: "16px",
          border: "1px solid #E9EAEA",
          width: "282px",
          userSelect: "none",
          height: "100%"
        }}
      >
        <CardContent
          sx={{
            py: 4,
            px: 3,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start"
          }}
        >
          <Stack>
            <Typography fontWeight={600} fontSize={24} lineHeight="28px" color="#0045B5" mb={2} style={{ wordBreak: "break-word" }}>
              {title}
            </Typography>
          </Stack>

          <Typography component="span" fontWeight={400} fontSize={14} lineHeight="19.6px" color="#58595B" style={{ wordBreak: "break-word" }}>
            {documentToReactComponents(description as Document, richTextRendererUtils)}
          </Typography>
        </CardContent>
      </Stack>
    </Box>
  );
};
